import {object, string, number, array} from 'yup';

export const addRoomSchema = object({
    number : number()
    .min(0, 'Room number cannot be less than 0')
    .required('Room number is required')
    .typeError('Invalid field'),
    type: string().required("type is required"),
    status: string().required("Please choose rooom status"),   
})